
define('jst!peoplefinder/_email',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="email-tab">\n  <%= lead_text %>\n  <input type="text" />\n</div>\n');
 });

